import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Spin,
  Select,
  InputNumber,
  Modal,
  DatePicker,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { save } from "../../../../../../../features/save/saveSlice";
import { normalizeDateToLocalYear } from "../../../../../../../utils";

const ActivityAdd = ({
  isModalOpen,
  handleCancel,
  handleFetch,
  prodd,
  prodd2,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  
  const onFinish = async (data) => { 
    data.paId = prodd?.paId ? prodd?.paId : null;
    data.paComponentId =prodd?.paId ? prodd?.paComponentId :   prodd2?.paComponentId
    data.paStartDate = normalizeDateToLocalYear(data?.paStartDate);
    data.paEndDate = normalizeDateToLocalYear(data?.paEndDate);
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/mainProject/activities/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
        paStartDate: prodd?.paStartDate
          ? dayjs(new Date(prodd?.paStartDate))
          : null,
        paEndDate: prodd?.paEndDate ? dayjs(new Date(prodd?.paEndDate)) : null,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <Modal
      title={`${
        prodd?.paId ? "Update Activity" : `Add a Activity to ${prodd2?.paComponetName}`
      }`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[42.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          name="activityName"
          className=""
          label={"Name"}
          rules={[
            {
              required: true,
              message: "Please add name",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>

        <Form.Item
          name="paStartDate"
          rules={[
            {
              required: true,
              message: "Start date is required",
            },
          ]}
          label="Start Date"
        >
          <DatePicker format={"YYYY MMM DD"} className="input" />
        </Form.Item>

        <Form.Item
          name="paEndDate"
          rules={[
            {
              required: true,
              message: "End date is required",
            },
          ]}
          label="End Date"
        >
          <DatePicker format={"YYYY MMM DD"} className="input" />
        </Form.Item>
        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? (
                  <Spin />
                ) : prodd?.paId ? (
                  "Update Activity"
                ) : (
                  "Save Activity"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default ActivityAdd;
